// @flow
import * as actionTypes from '../constants/action_types'
import * as ids from '../constants/ids'

export type AnalyzeFrameworkBarType = {
    // Themes with intervals can be aninated over intervals.
    animationType: 'interval' | 'frame',
    // If visible but should not be shown because context bar is hidden
    hidden: boolean,
    // The current raster or transim being displayed within the current theme and interval.
    iframe: number,
    // The current interval
    iInterval: number,
    // Ordering of frames in animation
    iterationOrder: Array<number>,
    iterationType: 'default' | 'value' | 'grayswan' | 'valueGrayswan',
    // Which directory to use for raster display (ie, _quickOverview, _allRealizations
    modes: string[],
    // Current directory mode
    mode: string,
    ntransitions: number,
    showLabels: boolean,
    sortRealizations: boolean,
    // The time between frame changes
    speedFrame: number,
    // The time between transitions between frames
    speedTransition: number,
    started: boolean,
    visible: boolean,
}

export type AnalyzeFrameworkBarActionType = {
    id: string,
    type?: string,
    config?: AnalyzeFrameworkBarType,
    mode?: string,
}

const initialState = {
    animationType: 'frame',
    hidden: false,
    iframe: 2,
    iInterval: 0,
    iterationOrder: [],
    iterationType: 'default',
    modes: ['_quickOverview', '_allRealizations', '_ranges'],
    mode: '_quickOverview',
    ntransitions: 10,
    showLabels: false,
    sortRealizations: false,
    speedFrame: 2000,
    speedTransition: 500,
    started: false,
    visible: true,
}

export default function AnalyzeFrameworkBar(state: AnalyzeFrameworkBarType = initialState, action: AnalyzeFrameworkBarActionType) {
    let newstate = { ...state }

    if (action.type === actionTypes.CLICK_CONTEXT_BAR_ITEM) {
        if (action.id === ids.ANALYZE_FRAMEWORK) {
            // Toggle the control bar if clicking an already-active framework button.
            // Otherwise, always show the control bar.
            newstate = (action.active
                ? { ...state, visible: !state.visible }
                : { ...state, visible: true })
        } else {
            // Pause animation
            newstate = { ...state, started: false }
        }
    } else if (action.type === actionTypes.CLOSE_CONTEXT_BAR_ITEMS) {
        newstate = { ...state, hidden: state.visible, visible: false }
    } else if (action.type === actionTypes.OPEN_CONTEXT_BAR_ITEMS) {
        newstate = { ...state, visible: state.hidden, hidden: false }
    } else if (action.type === actionTypes.SET_FICUS_CONFIG) {
        newstate = {
            ...state,
            ...action.config,
        }
    } else if (action.type === actionTypes.RECEIVE_FICUS_DATA) {
        // Reset controls to initial state
        newstate = {
            ...state,
            animationType: 'frame',
            mode: action.mode,
            iframe: action.mode === '_quickOverview' ? 2 : 0,
            iInterval: 0,
        }
    } else if (action.type === actionTypes.SET_ANALYZE_MODE) {
        newstate = {
            ...state,
            animationType: 'frame',
            mode: action.mode,
            iframe: action.mode === '_quickOverview' ? 2 : 0,
            iInterval: 0,
        }
    } else if (action.type === actionTypes.REMOVE_MAP_LOCATIONS) {
        newstate = {
            ...state,
        }
        // Reset iteration type if set on cell value mode
        if (state.iterationType === 'value') newstate.iterationType = 'default'
    }

    return newstate
}
